import { toastCreateOperationCatcher, toastSuccessMessage } from "./alerts";

import { serverBulkCreateSubmissions } from "api/api-server-actions";
import { shouldLockPageOnSubmissionCollect } from "components/materials/page/helpers";
import { PageType } from "components/server-types";
import { t } from "i18n/i18n";
import { slices, useAppDispatch } from "store/index";
import { sectionSelectors } from "store/selectors";
import { useObjectSelector } from "store/store-hooks";

export const useSubmissions = (
  page: Pick<
    PageType,
    | "due_at"
    | "id"
    | "late_submission_interval"
    | "locked_at"
    | "section_id"
    | "should_lock_at_due_date"
  > | null,
) => {
  const dispatch = useAppDispatch();

  const sectionShouldLockPagesAtDueDate = useObjectSelector(
    (s) => sectionSelectors.selectById(s, page?.section_id),
    ["should_lock_pages_at_due_date"],
  )?.should_lock_pages_at_due_date;

  const createSubmissions = () => {
    if (!page) {
      return;
    }

    const shouldLock = shouldLockPageOnSubmissionCollect(
      page ?? null,
      sectionShouldLockPagesAtDueDate,
    );

    const previousLockedAt = page?.locked_at ?? null;

    if (shouldLock) {
      dispatch(
        slices.pages.actions.patchOne({
          id: page.id,
          locked_at: new Date().toISOString(),
        }),
      );
    }

    return serverBulkCreateSubmissions(page.id, shouldLock)
      .then(() => toastSuccessMessage(t("success.toasts.submission_success_other")))
      .catch((error: unknown) => {
        if (shouldLock) {
          dispatch(
            slices.pages.actions.patchOne({
              id: page.id,
              locked_at: previousLockedAt,
            }),
          );
        }

        toastCreateOperationCatcher("submission")(error);
      });
  };

  return { createSubmissions };
};
